import { _, addMessages, locale } from 'svelte-i18n'

import en from './en.json'
// import de from './de.json'

export function setupChatI18n(): void {
	addMessages('en', en)
	// addMessages('de', de)
	addMessages('de', en) // TEMP: use English for German locale
}

export { locale as chatLocale, _ as chatT }
